import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

type Props = {
  title?: string
  selected: string[]
  options?: { label: string, id: number, color: string }[]
  onChange: (selected: string[]) => void
}

const FilterWidget = ({ title, selected, options, onChange }: Props) => {
  
  const handleToggle = (value: string) => {
    const updated = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onChange(updated);
  };
  return (
    <FormGroup>
      <Typography variant="caption" sx={{ mb: 1, fontWeight: 600 }}>{title}</Typography>
      {options?.map((option) => (
        <FormControlLabel
          key={option.id}
          control={<Checkbox
            checked={selected.includes(option.label)}
            onChange={() => handleToggle(option.label)}
          />}
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {option.color && (
                <Box sx={{ width: 14, height: 14, bgcolor: option.color, borderRadius: "3px" }} />
              )}
              <Typography variant="caption">{option.label}</Typography>
            </Box>
          }
        />
      ))}
    </FormGroup>
  );
};

export default FilterWidget;

